import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";

export default function ComingSoon({ title }) {
  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 bg-gray-900 min-h-screen">
        <Topbar title={title} />

        <div className="flex items-center justify-center h-[80vh] text-gray-400 text-2xl">
          🚧 {title} – Coming Soon
        </div>
      </div>
    </div>
  );
}
